import React from "react";
import { Radio } from "@mui/material";
import { useField, useForm, useFormState } from "react-final-form";
import { SettingRow } from "../SettingRow";
import { BannerCopyVariant } from "../../../../../../common/service/server/dto/CMPSettingsDto";

const BUTTON_PREVIEW_OPTIONS = [
  {
    value: BannerCopyVariant.DEFAULT,
    buttons: ["Manage", "Decline", "Accept"],
  },
  {
    value: BannerCopyVariant.CUSTOMIZE_STRICTLY_NECESSARY_ACCEPT_ALL,
    buttons: ["Customize", "Strictly Necessary", "Accept All"],
  },
];

export const ConsentBannerOptInButtonTextRow = () => {
  const form = useForm();
  useField("bannerCopyVariant", { subscription: {} });
  const { values } = useFormState<{ bannerCopyVariant?: BannerCopyVariant }>({
    subscription: { values: true },
  });

  const selectedValue = values.bannerCopyVariant || BannerCopyVariant.DEFAULT;

  return (
    <SettingRow
      maxWidthChildren={true}
      title="Opt-In Banner Button Text"
      helpText="Customize the text for the opt-in banner buttons. This applies only for the opt-in banner (non-GDPR)."
    >
      <div className="d-flex flex-column" style={{ gap: "1rem" }}>
        {BUTTON_PREVIEW_OPTIONS.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <div
              key={option.value}
              className="d-flex align-items-center"
              style={{ gap: "0.75rem", cursor: "pointer" }}
              onClick={() => form.change("bannerCopyVariant", option.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  form.change("bannerCopyVariant", option.value);
                }
              }}
              role="button"
              tabIndex={0}
            >
              <Radio
                color="primary"
                checked={isSelected}
                name="bannerCopyVariant"
                onChange={() => form.change("bannerCopyVariant", option.value)}
              />
              <div
                className="d-flex align-items-center"
                style={{
                  gap: option.value === BannerCopyVariant.DEFAULT ? "1rem" : "0.5rem",
                  padding: "12px 16px",
                  borderRadius: "20px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.12)",
                  flexWrap: "nowrap",
                  width: "432px",
                  maxWidth: "100%",
                }}
              >
                {option.buttons.map((label, index) => {
                  const isLink = index === 0;
                  return (
                    <span
                      key={label}
                      style={
                        isLink
                          ? {
                              padding: "4px 8px",
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#0a66c2",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                            }
                          : {
                              padding: "4px 8px",
                              borderRadius: "999px",
                              border: "1px solid #e4deef",
                              backgroundColor: "#ffffff",
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#3f3854",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.10)",
                              whiteSpace: "nowrap",
                              minWidth: "150px",
                              textAlign: "center",
                            }
                      }
                    >
                      {label}
                    </span>
                  );
                })}
              </div>
              {option.value === BannerCopyVariant.DEFAULT && (
                <span style={{ fontSize: "14px", color: "#4a3fb3" }}>Default</span>
              )}
            </div>
          );
        })}
      </div>
    </SettingRow>
  );
};
